import { render, staticRenderFns } from "./AttributeMetrics.vue?vue&type=template&id=6315e4b4&scoped=true"
import script from "./AttributeMetrics.vue?vue&type=script&lang=js"
export * from "./AttributeMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315e4b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6315e4b4')) {
      api.createRecord('6315e4b4', component.options)
    } else {
      api.reload('6315e4b4', component.options)
    }
    module.hot.accept("./AttributeMetrics.vue?vue&type=template&id=6315e4b4&scoped=true", function () {
      api.rerender('6315e4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/managment/AttributeMetrics.vue"
export default component.exports